// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"270cac89","147":"3456cdce","152":"3b4ef828","198":"5c830e18","362":"fd9aa5e7","404":"3ac5f455","480":"8d0a9dd2","541":"7fbd2945","579":"8661e51a","639":"4d57a749","747":"f0ccc480","854":"ff43e1d7"}[chunkId] + ".chunk.js";
};